import { OrgInfo } from '@app/account/account-api.model';
import { GroupPermissionsService } from '@app/groups/services/group-permissions.service';
import { ManagedGroup } from '@app/orgs/services/org-groups.service';
import { AuthService, AuthUser } from '@degreed/lxp/services/authorization';

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FtpFileUploadType } from '@app/ftp/ftp-api.model';
import { Filter } from '@app/shared/components/filter/filter.component';
import { ContextService } from '@degreed/lxp/services';

@Component({
  selector: 'dgx-org-groups-header',
  templateUrl: './org-groups-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class OrgGroupsHeaderComponent implements OnInit {
  @Input() public groups: ManagedGroup[];
  @Input() public isLoading: boolean;
  @Input() public orgId: number;
  @Input() public filters: Filter[];

  @Output() public updateQueries = new EventEmitter();
  @Output() public filtersChange = new EventEmitter<{
    filters: Filter[];
    id: string;
  }>();

  public canCreateAnyGroup: boolean;
  public canUploadGroups: boolean;
  public searchTerm: string;
  public useNewGroupSettingsLDFlag: any;
  public readonly fileType = FtpFileUploadType.Groups;

  public isChannelContext = this.contextService.urlInChannel();
  public isClientProvider =
    this.authService.authUser?.defaultOrgInfo?.settings?.isClientProvider;

  private authUser: AuthUser;
  private orgInfo: OrgInfo;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private contextService: ContextService,
    private groupPermissionsService: GroupPermissionsService
  ) {}

  public get selectedGroups() {
    return this.groups.filter((group) => group.isSelected);
  }

  public ngOnInit(): void {
    this.authUser = this.authService.authUser;
    this.orgInfo = this.authUser.orgInfo.find(
      (x) => x.organizationId === this.orgId
    );

    // This should eventually check against the same service the FTP guard
    //   uses HOWEVER currently issues with doubling this component in org
    //   and channel prevents us from doing this.
    this.canUploadGroups =
      this.authUser.canBulkUpload && this.orgInfo.permissions.uploadGroups;

    this.canCreateAnyGroup = this.groupPermissionsService.canCreateAnyGroup(
      this.orgInfo.permissions
    );
  }

  public addGroup(event) {
    this.router.navigate(['create'], { relativeTo: this.route });
  }

  public updateQuery(term: string) {
    this.searchTerm = term;
    this.updateQueries.emit(this.searchTerm);
  }

  public updateFilters($event: { filters: Filter[]; id: string }) {
    this.filtersChange.emit($event);
  }
}
